import React from "react";

import { FormattedMessage } from "react-intl";

import { StyledWhy } from "./styles";
import messages from "./messages";
import FormattedHtmlMessage from "../../../../common/helpers/FormattedHtmlMessage";

const Why = () => (
    <StyledWhy>
        <h2>
            <FormattedMessage {...messages.h2} />
        </h2>
        <p>
            <FormattedHtmlMessage {...messages.p} />
        </p>
    </StyledWhy>
);

export default Why;
